export const ValidationFailedReasonType = {
    /** 회원님은 해당 판매자의 상품 구매가 불가 합니다.\n자세한 사항은 상품 Q&A를 통해 판매자에게 문의하여 주시기 바랍니다. */
    BLACK_CONSUMER: 'BLACK_CONSUMER',
    /** 배송지 정보를 입력해야 합니다. */
    BLANK_DELIVERY_ADDRESS_INFORMATION: 'BLANK_DELIVERY_ADDRESS_INFORMATION',
    /** 상세주소를 입력해야 합니다. */
    BLANK_DELIVERY_ADDRESS_NOT_ROAD_DETAIL_ADDRESS: 'BLANK_DELIVERY_ADDRESS_NOT_ROAD_DETAIL_ADDRESS',
    /** 수령인을 입력해야 합니다. */
    BLANK_DELIVERY_ADDRESS_RECEIVER_NAME: 'BLANK_DELIVERY_ADDRESS_RECEIVER_NAME',
    /** 수령인을 입력해야 합니다. */
    BLANK_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: 'BLANK_DELIVERY_NOTHING_ORDER_RECEIVER_NAME',
    /** 해외직배송 상품 통관처리를 위해 개인통관고유부호를 입력해 주세요. */
    BLANK_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: 'BLANK_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE',
    /** 환불계좌 정보를 선택해 주세요. */
    BLANK_REFUND_ACCOUNT_BANK_INFORMATION: 'BLANK_REFUND_ACCOUNT_BANK_INFORMATION',
    /** 네이버페이 머니 사용자 상태가 올바르지 않습니다. 다시 시도해 주세요. */
    CHARGE_POINT_USER_STATUS_NOT_MATCHED: 'CHARGE_POINT_USER_STATUS_NOT_MATCHED',
    /** 배송 메모는 최대 500자까지 입력 가능합니다. */
    DELIVERY_MEMO_LENGTH_LIMIT_EXCEEDED: 'DELIVERY_MEMO_LENGTH_LIMIT_EXCEEDED',
    /** 선택하신 배송지 우편번호가 폐지되어 사용 불가합니다. */
    DEPRECATED_DELIVERY_ADDRESS_ZIPCODE: 'DEPRECATED_DELIVERY_ADDRESS_ZIPCODE',
    DETAIL_ADDRESS_LENGTH_LIMIT_EXCEEDED: 'DETAIL_ADDRESS_LENGTH_LIMIT_EXCEEDED',
    /** 같은 배송비 쿠폰을 중복 사용할 수 없습니다. */
    DUPLICATED_SELECTED_DELIVERY_FEE_COUPON: 'DUPLICATED_SELECTED_DELIVERY_FEE_COUPON',
    /** 같은 상품 쿠폰을 중복 사용할 수 없습니다. */
    DUPLICATED_SELECTED_PRODUCT_COUPON: 'DUPLICATED_SELECTED_PRODUCT_COUPON',
    /** 보유한 네이버페이 머니 보다 많은 금액은 사용하실 수 없습니다. 다시 주문해주세요. */
    EXCEED_CHARGE_POINT_BALANCE_AMOUNT: 'EXCEED_CHARGE_POINT_BALANCE_AMOUNT',
    /** 배송지명은 최대 50자까지 입력 가능합니다. */
    EXCEED_DELIVERY_ADDRESS_NAME: 'EXCEED_DELIVERY_ADDRESS_NAME',
    EXCEED_DELIVERY_ADDRESS_RECEIVER_NAME: 'EXCEED_DELIVERY_ADDRESS_RECEIVER_NAME',
    /** 수령인은 최대 50자까지 입력 가능합니다. */
    EXCEED_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: 'EXCEED_DELIVERY_NOTHING_ORDER_RECEIVER_NAME',
    EXCEED_MINOR_PAY_AMOUNT: 'EXCEED_MINOR_PAY_AMOUNT',
    /** 후불 결제시 사용할 수 있는 한도 금액을 초과하였습니다. */
    EXCEED_PAY_LATER_AVAILABLE_AMOUNT: 'EXCEED_PAY_LATER_AVAILABLE_AMOUNT',
    /** 충전 가능 금액이 부족하여 네이버페이 머니 충전결제 이용이 불가합니다. */
    EXCEED_RECHARGE_LIMIT: 'EXCEED_RECHARGE_LIMIT',
    /** 보유한 네이버페이 포인트 보다 많은 금액은 사용하실 수 없습니다. 다시 주문해주세요. */
    EXCEED_REWARD_POINT_BALANCE_AMOUNT: 'EXCEED_REWARD_POINT_BALANCE_AMOUNT',
    /** 모바일쿠폰/상품권 및 지류/상품권 카테고리 상품 일 결제금액 한도 50만원을 초과하여 결제가 불가합니다. */
    EXCEED_TODAY_GIFT_CERTIFICATION_USAGE_AMOUNT: 'EXCEED_TODAY_GIFT_CERTIFICATION_USAGE_AMOUNT',
    /** 네이버페이 머니 잔액 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_CHARGE_POINT_BALANCE: 'FAILED_GET_CHARGE_POINT_BALANCE',
    /** 사용자 요청이 많아 네이버페이 머니 잔액 정보를 불러오지 못했습니다. 잠시후 다시 시도해 주세요. */
    FAILED_GET_CHARGE_POINT_BALANCE_TPS_EXCEED: 'FAILED_GET_CHARGE_POINT_BALANCE_TPS_EXCEED',
    /** 은행시스템 점검 중 입니다. 네이버페이 머니 잔액 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_CHARGE_POINT_BALANCE_BANK_MAINTENANCE: 'FAILED_GET_CHARGE_POINT_BALANCE_BANK_MAINTENANCE',
    /** 네이버페이 머니 회원정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_CHARGE_POINT_USER: 'FAILED_GET_CHARGE_POINT_USER',
    /** 네이버페이 머니 충전정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_RECHARGEABLE_CHARGE_POINT_AMOUNT: 'FAILED_GET_RECHARGEABLE_CHARGE_POINT_AMOUNT',
    /** 현재 미성년자 한도 확인이 되지 않아 주문이 불가합니다. 잠시 후 재시도 부탁드립니다. */
    FAILED_GET_MINOR_PAY_AMOUNT: 'FAILED_GET_MINOR_PAY_AMOUNT',
    /** 네이버페이 포인트 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. */
    FAILED_GET_REWARD_POINT_BALANCE: 'FAILED_GET_REWARD_POINT_BALANCE',
    /** 최대할부기간을 초과할 수 없습니다 */
    INSTALLMENT_MONTH_LIMIT_EXCEEDED: 'INSTALLMENT_MONTH_LIMIT_EXCEEDED',
    /** 현금영수증 정보가 잘못되었습니다. */
    INVALID_CASH_RECEIPT: 'INVALID_CASH_RECEIPT',
    /** 현금영수증 사업자번호를 확인 후 정확히 입력해주세요. */
    INVALID_CASH_RECEIPT_BUSINESS_REGISTRATION_NUMBER: 'INVALID_CASH_RECEIPT_BUSINESS_REGISTRATION_NUMBER',
    /** 현금영수증 휴대폰번호를 확인 후 정확히 입력해주세요. */
    INVALID_CASH_RECEIPT_PR_CELL_PHONE_NUMBER: 'INVALID_CASH_RECEIPT_PR_CELL_PHONE_NUMBER',
    /** 정확한 카드번호를 입력해 주세요. */
    INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_CARD_NUMBER: 'INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_CARD_NUMBER',
    /** 현금영수증 전용카드는 총 18자리 입니다. 정확한 카드번호를 입력해 주세요. */
    INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_VOLUNTARY_ISSUANCE_CARD_NUMBER:
        'INVALID_CASH_RECEIPT_PR_CASH_RECEIPT_VOLUNTARY_ISSUANCE_CARD_NUMBER',
    /** 비정상적인 네이버페이 머니 사용 요청입니다. 다시 시도해 주세요. */
    INVALID_CHARGE_POINT_AMOUNT: 'INVALID_CHARGE_POINT_AMOUNT',
    /** 연락처1의 입력하신 정보를 확인해 주세요. */
    INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO1: 'INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO1',
    /** 연락처2의 입력하신 정보를 확인해 주세요. */
    INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO2: 'INVALID_FORMAT_DELIVERY_ADDRESS_TEL_NO2',
    /** 우편번호는 5,6자리 숫자만 허용합니다. */
    INVALID_FORMAT_DELIVERY_ADDRESS_ZIPCODE: 'INVALID_FORMAT_DELIVERY_ADDRESS_ZIPCODE',
    /** 선택하신 배송지의 우편번호 혹은 주소명이 정확하지 않습니다. 원활한 배송을 위해 배송지 정보를 업데이트 해주세요. */
    INVALID_ZIPCODE_AND_ADDRESS: 'INVALID_ZIPCODE_AND_ADDRESS',
    /** 상품 수신을 위한 휴대폰 번호를 입력해 주세요. */
    INVALID_FORMAT_DELIVERY_NOTHING_ORDER_RECEIVER_PHONE_NUMBER:
        'INVALID_FORMAT_DELIVERY_NOTHING_ORDER_RECEIVER_PHONE_NUMBER',
    /** 개인통관고유부호를 정확히 입력해주세요. */
    INVALID_FORMAT_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: 'INVALID_FORMAT_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE',
    /** 카드사를 선택하셔야 합니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_COMPANY_CODE: 'INVALID_GENERAL_PAY_METHOD_CARD_COMPANY_CODE',
    /** 결제수단 정보가 잘못되었습니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT: 'INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT',
    /** 할부기간을 선택하셔야 합니다. */
    INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT_MONTH: 'INVALID_GENERAL_PAY_METHOD_CARD_INSTALLMENT_MONTH',
    /** 휴대폰 간편결제 비밀번호 4자리를 입력해 주십시오. */
    INVALID_GENERAL_PAY_METHOD_MOBILE_EASY_PAY_PIN_NO: 'INVALID_GENERAL_PAY_METHOD_MOBILE_EASY_PAY_PIN_NO',
    /** 휴대폰번호를 입력해주세요. | 잘못된 휴대폰 번호입니다. */
    INVALID_GENERAL_PAY_METHOD_MOBILE_PHONE_NUMBER: 'INVALID_GENERAL_PAY_METHOD_MOBILE_PHONE_NUMBER',
    INVALID_GENERAL_PAY_METHOD_SKIP: 'INVALID_GENERAL_PAY_METHOD_SKIP',
    INVALID_GENERAL_PAY_METHOD_TYPE: 'INVALID_GENERAL_PAY_METHOD_TYPE',
    INVALID_GENERAL_PAY_METHOD_TYPE_PAY_AMOUNT: 'INVALID_GENERAL_PAY_METHOD_TYPE_PAY_AMOUNT',
    INVALID_GENERAL_PAY_METHOD_VIRTUAL_ACCOUNT_BANK_CODE: 'INVALID_GENERAL_PAY_METHOD_VIRTUAL_ACCOUNT_BANK_CODE',
    /** 모바일쿠폰/상품권 및 지류/상품권 카테고리 상품 일 결제금액 한도 조회에 오류가 발생했습니다. */
    INVALID_GIFT_CERTIFICATION_USAGE_AMOUNT: 'INVALID_GIFT_CERTIFICATION_USAGE_AMOUNT',
    /** 가격정보가 올바르지 않습니다. */
    INVALID_ITEM_PAY_AMOUNT: 'INVALID_ITEM_PAY_AMOUNT',
    /** 주문 금액이 올바르지 않습니다. 주문서 새로고침 후 확인해 주시기 바랍니다. */
    INVALID_ORDER_PAY_AMOUNT: 'INVALID_ORDER_PAY_AMOUNT',
    INVALID_PAY_LATER_ORDER: 'INVALID_PAY_LATER_ORDER',
    INVALID_PAY_LATER_PAY_AMOUNT: 'INVALID_PAY_LATER_PAY_AMOUNT',
    INVALID_PAY_LATER_RECHARGE_POINT: 'INVALID_PAY_LATER_RECHARGE_POINT',
    INVALID_PAY_LATER_SKIP: 'INVALID_PAY_LATER_SKIP',
    /** 후불결제 연체로 결제가 제한되었습니다. 납부 후 결제가 가능하니 즉시 납부 부탁드립니다 */
    INVALID_PAY_LATER_USER_OVERDUE_PENALTY_STATUS: 'INVALID_PAY_LATER_USER_OVERDUE_PENALTY_STATUS',
    /** 후불 결제를 사용할 수 없는 회원 상태입니다. */
    INVALID_PAY_LATER_USER_STATUS: 'INVALID_PAY_LATER_USER_STATUS',
    /** 후불결제시 포인트가 전액 사용되어야 합니다. */
    INVALID_PAY_LATER_WITH_NOT_USE_ALL_POINTS: 'INVALID_PAY_LATER_WITH_NOT_USE_ALL_POINTS',
    INVALID_PAY_REQUEST: 'INVALID_PAY_REQUEST',
    /** 비정상적인 네이버페이 머니 사용 요청입니다. 다시 시도해 주세요. */
    INVALID_RECHARGE_AMOUNT: 'INVALID_RECHARGE_AMOUNT',
    INVALID_RECHARGE_POINT_AMOUNT: 'INVALID_RECHARGE_POINT_AMOUNT',
    /** 비정상적인 네이버페이 포인트 사용 요청입니다. 다시 시도해 주세요. */
    INVALID_REWARD_POINT_AMOUNT: 'INVALID_REWARD_POINT_AMOUNT',
    /** 선택된 쿠폰/할인은 사용할 수 없습니다. */
    INVALID_SELECTED_DELIVERY_FEE_COUPON: 'INVALID_SELECTED_DELIVERY_FEE_COUPON',
    /** 선택된 쿠폰/할인은 사용할 수 없습니다. */
    INVALID_SELECTED_PRODUCT_COUPON: 'INVALID_SELECTED_PRODUCT_COUPON',
    /** 결제수단 정보가 잘못되었습니다. */
    INVALID_SUB_PAY_METHOD_TYPE: 'INVALID_SUB_PAY_METHOD_TYPE',
    /** 결제수단 정보가 잘못되었습니다. */
    INVALID_SUB_PAY_METHOD_TYPE_PAY_AMOUNT: 'INVALID_SUB_PAY_METHOD_TYPE_PAY_AMOUNT',
    /** 유효하지 않은 회원입니다. */
    MEMBER_NO_NOT_MATCHED: 'MEMBER_NO_NOT_MATCHED',
    MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED: 'MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED',
    MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID:
        'MEMBERSHIP_QUICK_JOIN_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID',
    MEMBERSHIP_QUICK_JOIN_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY:
        'MEMBERSHIP_QUICK_JOIN_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY',
    MEMBERSHIP_QUICK_JOIN_FAILED_UNCATEGORIZED_ERROR: 'MEMBERSHIP_QUICK_JOIN_FAILED_UNCATEGORIZED_ERROR',
    /** 유효하지 않은 가맹점입니다. */
    MERCHANT_STATUS_NOT_NORMAL: 'MERCHANT_STATUS_NOT_NORMAL',
    /** 환불방법을 선택하세요. */
    MISSING_REFUND_ACCOUNT_METHOD_TYPE: 'MISSING_REFUND_ACCOUNT_METHOD_TYPE',
    MOBILE_PAYMENT_LIMIT_EXCEEDED: 'MOBILE_PAYMENT_LIMIT_EXCEEDED',
    /** 네이버 회원 인증에 실패하였습니다. */
    NAVERPAY_AUTHENTICATION_VALIDATION_FAILED: 'NAVERPAY_AUTHENTICATION_VALIDATION_FAILED',
    /** 네이버 회원 인증 실패 (비밀번호 재설정) */
    NAVERPAY_AUTHENTICATION_VALIDATION_FAILED_PASSWORD_RESET:
        'NAVERPAY_AUTHENTICATION_VALIDATION_FAILED_PASSWORD_RESET',
    /** 해외직배송 상품 통관처리를 위한 고유식별정보 수집 및 제공 동의에 체크해 주세요. */
    NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_COLLECTION:
        'NOT_AGREED_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_COLLECTION',
    /** 주문자 정보의 휴대폰 번호와 수신자 휴대폰 번호가 일치하지 않습니다. */
    NOT_MATCHED_DELIVERY_NOTHING_ORDER_PURCHASER_PHONE_NUMBER:
        'NOT_MATCHED_DELIVERY_NOTHING_ORDER_PURCHASER_PHONE_NUMBER',
    /** 개인통관고유부호 필요 여부를 선택해주세요. */
    NULL_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_NEEDED: 'NULL_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE_NEEDED',
    /** 이미 완료된 주문 */
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    ORDER_APPLY_REQUIREMENT_MISSING: 'ORDER_APPLY_REQUIREMENT_MISSING',
    /** 네이버페이 머니 사용자 상태가 변경 되었습니다. 다시 시도해 주세요. */
    REFRESHED_CHARGE_POINT_USER_STATUS: 'REFRESHED_CHARGE_POINT_USER_STATUS',
    /** 해외직배송상품은 통관진행 및 원활한 배송처리를 위해 도로명주소+5자리 우편번호로 입력하셔야 합니다.\n배송지 주소를 도로명 주소로 수정해주세요. */
    REJECT_OVERSEA_DELIVERY_NOT_ROAD_ADDRESS: 'REJECT_OVERSEA_DELIVERY_NOT_ROAD_ADDRESS',
    /** 보유 네이버페이 머니로 결제가 가능하여, 충전이 불가능합니다. */
    REJECT_RECHARGE_PAYMENT_OF_OPENED_USER_WITH_ENOUGH_BALANCE:
        'REJECT_RECHARGE_PAYMENT_OF_OPENED_USER_WITH_ENOUGH_BALANCE',
    /** 선택하신 국번은 안심번호 이용신청이 불가합니다. */
    REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO1: 'REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO1',
    /** 선택하신 국번은 안심번호 이용신청이 불가합니다. */
    REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO2: 'REJECT_VIRTUAL_PHONE_NUMBER_DELIVERY_ADDRESS_TEL_NO2',
    /** 해당 판매자의 상품은 수입신고 진행을 위해 안심번호 서비스 제공이 불가합니다. */
    REJECT_VIRTUAL_PHONE_NUMBER_OVERSEA_DELIVERY: 'REJECT_VIRTUAL_PHONE_NUMBER_OVERSEA_DELIVERY',
    REMOTE_API_SERVER_ERROR: 'REMOTE_API_SERVER_ERROR',
    /** 대기열 순번이 만료되었습니다. */
    TICKET_EXPIRED: 'TICKET_EXPIRED',
    /** 네이버페이 머니 충전결제를 사용할 수 없는 사용자 상태입니다. */
    UNAVAILABLE_CHARGE_POINT_USER_STATUS: 'UNAVAILABLE_CHARGE_POINT_USER_STATUS',
    /** 후불결제 시스템 점검 중입니다. 다른 결제수단을 이용해 주세요. */
    UNAVAILABLE_PAY_LATER_SERVICE: 'UNAVAILABLE_PAY_LATER_SERVICE',
    UNCATEGORIZED_ERROR: 'UNCATEGORIZED_ERROR',
    /** 개인고유통관부호가 필요하지 않은 주문입니다. 재시도 또는 고객센터 문의바랍니다. */
    UNNECESSARY_PERSONAL_CUSTOMS_CODE: 'UNNECESSARY_PERSONAL_CUSTOMS_CODE',
    VERIFY_SERVER_CLIENT_DATA_DO_NOT_MATCH: 'VERIFY_SERVER_CLIENT_DATA_DO_NOT_MATCH',
    /** 현재 안심번호 서비스가 일시 중단된 상태입니다. 안심번호 사용신청이 취소됩니다. */
    VIRTUAL_PHONE_NUMBER_SERVICE_UNAVAILABLE: 'VIRTUAL_PHONE_NUMBER_SERVICE_UNAVAILABLE',

    /**
     * 아래 내용은 하위 호환성을 위해 통합 후 삭제 예정
     */
    /** 배송지명은 최대 50자까지 입력 가능합니다. */
    EXCESS_DELIVERY_ADDRESS_NAME: 'EXCESS_DELIVERY_ADDRESS_NAME',
    /** 수령인은 최대 50자까지 입력 가능합니다. */
    EXCESS_DELIVERY_ADDRESS_RECEIVER_NAME: 'EXCESS_DELIVERY_ADDRESS_RECEIVER_NAME',
    /** 수령인은 최대 50자까지 입력 가능합니다. */
    EXCESS_DELIVERY_NOTHING_ORDER_RECEIVER_NAME: 'EXCESS_DELIVERY_NOTHING_ORDER_RECEIVER_NAME',
    INVALID_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE: 'INVALID_OVERSEA_DELIVERY_PERSONAL_CUSTOMS_CODE',
    /** 현재 구매 불가능한 상태의 판매자 상품입니다. */
    MERCHANT_STATUS: 'MERCHANT_STATUS',
} as const
